import React from "react";
import { motion } from "framer-motion";
import { Bus } from "lucide-react";
import { FACILITIES, IMAGES } from "@/lib/constants";
import { PageBanner } from "@/components/PageBanner";
import { SectionHeading } from "@/components/SectionHeading";
import { Icon } from "@/components/Icon";

export default function Facilities() {
  return (
    <div>
      <PageBanner title="Facilities" subtitle="Modern infrastructure designed for safe, joyful and effective learning." image={IMAGES.computerLab} />

      <section className="max-w-7xl mx-auto px-6 py-20">
        <SectionHeading center label="Our Infrastructure" title="World-class facilities for young learners" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FACILITIES.map((f, i) => (
            <motion.div key={f.title} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.06 }}
              className="group bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl transition-transform hover:-translate-y-1">
              <div className="relative h-52 overflow-hidden">
                <img src={f.image} alt={f.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute top-3 left-3 h-11 w-11 rounded-xl glass grid place-items-center text-brandred"><Icon name={f.icon} className="h-6 w-6" /></div>
              </div>
              <div className="p-6">
                <h3 className="font-head font-bold text-navy text-lg">{f.title}</h3>
                <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-6 bg-navy rounded-3xl p-8 flex flex-col sm:flex-row items-center gap-6 text-white">
          <div className="h-16 w-16 rounded-2xl bg-gold/20 text-gold grid place-items-center shrink-0"><Bus className="h-8 w-8" /></div>
          <div>
            <h3 className="font-head font-bold text-xl">School Transport</h3>
            <p className="text-slate-300 text-sm mt-1.5 leading-relaxed">Safe, GPS-enabled transport facility available on select routes. Please contact the school office to check route availability for your area.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
